
import { createClient } from '@supabase/supabase-js';

// --- Stratégie de chargement des clés Supabase ---
// Cette approche est compatible avec un projet Vite standard et AI Studio.

// 1. Vite / Vercel: Vite remplace `import.meta.env` avec les vraies valeurs pendant le build.
//    Les variables sur Vercel DOIVENT être préfixées par VITE_ (ex: VITE_SUPABASE_URL).
// FIX: Cast `import.meta` to `any` to prevent TypeScript errors when `vite/client` types are not included in `tsconfig.json`.
const viteUrl = (import.meta as any).env?.VITE_SUPABASE_URL;
// FIX: Cast `import.meta` to `any` to prevent TypeScript errors when `vite/client` types are not included in `tsconfig.json`.
const viteAnonKey = (import.meta as any).env?.VITE_SUPABASE_ANON_KEY;

// 2. AI Studio: AI Studio injecte les variables dans `process.env`.
const envUrl = process.env.SUPABASE_URL;
const envAnonKey = process.env.SUPABASE_ANON_KEY;

// 3. Fallback / Secours: Lire depuis le localStorage si l'utilisateur les a entrées manuellement.
const storedUrl = typeof window !== 'undefined' ? localStorage.getItem('SUPABASE_URL') : null;
const storedAnonKey = typeof window !== 'undefined' ? localStorage.getItem('SUPABASE_ANON_KEY') : null;

// Priorité: Vite/Vercel > AI Studio > localStorage
const supabaseUrl = viteUrl || envUrl || storedUrl;
const supabaseAnonKey = viteAnonKey || envAnonKey || storedAnonKey;


interface SupabaseError {
    title: string;
    message: string;
}

// Si aucune clé n'est trouvée, nous définissons un objet d'erreur pour afficher la page de configuration manuelle.
export const supabaseConfigurationError: SupabaseError | null = (!supabaseUrl || !supabaseAnonKey)
  ? {
      title: "Configuration de la base de données requise",
      message: "L'application ne peut pas démarrer. Les variables d'environnement Supabase ne sont pas correctement configurées."
    }
  : null;

if (supabaseConfigurationError) {
    console.warn(`${supabaseConfigurationError.title}: ${supabaseConfigurationError.message}`);
}

// Nous utilisons des clés de secours non fonctionnelles pour permettre au client Supabase d'être initialisé
// sans planter, afin que l'application puisse se charger et afficher la page d'erreur de configuration si nécessaire.
const finalSupabaseUrl = supabaseUrl || "https://placeholder.supabase.co"; 
const finalSupabaseAnonKey = supabaseAnonKey || "placeholder.anon.key";

export const supabase = createClient(finalSupabaseUrl, finalSupabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});

/** URL de base des Edge Functions (pour appels fetch explicites avec Authorization) */
export const getSupabaseFunctionsUrl = (): string =>
  `${finalSupabaseUrl}/functions/v1`;

/** Headers à envoyer pour les Edge Functions (évite 401 Missing authorization header) */
export const getSupabaseEdgeFunctionHeaders = (): Record<string, string> => ({
  Authorization: `Bearer ${finalSupabaseAnonKey}`,
  "Content-Type": "application/json",
});